const styles = () => ({
    boxBtnNew: {
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
    },
    btnNew: {
        borderRadius: '40px',
        padding: '5px 40px',
        color: '#fff',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        padding: '.2rem 0 .2rem 1rem',
        justifyContent: 'space-between',
        borderBottom: '1px solid #ccc',
        marginBottom: '20px',
    },
    content: {
        position: 'relative',
        minWidth: '26rem',
        maxWidth: '72rem',
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        overflowY: 'scroll',
    },
    closeButton: {
        margin: '.3rem',
        height: 43,
        width: 43,
    },
});

export default styles;
